import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import BlockWrapper from '@v2/pages/machines/modules/now/components/Overview/components/BlockWrapper';
import { TourTarget } from '@components/tours';
import { WELCOME_TOUR_IDS } from '@components/tours/config/global/welcome/constants';
import { ActionArrow } from '@components/common/ActionArrow';
import { WithColor } from '@styles/colors';
import { useManageToolsBlock } from './hooks/useManageToolsBlock';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

export interface ToolsBlockProps extends WithColor {
  toolsLength: number;
}

const ToolsBlock: FC<ToolsBlockProps> = ({ C, toolsLength }) => {
  const { gapBetweenLines, handlePress, batchLoaded } = useManageToolsBlock();

  return (
    <TourTarget tourId={WELCOME_TOUR_IDS.LIVE_TOOLS_BLOCK} style={{ flex: 1 }}>
      <BlockWrapper
        testID={TEST_IDS.liveScreen.toolsBlock}
        onPress={batchLoaded ? handlePress : undefined}
        containerStyle={{
          flex: 1,
          paddingVertical: scale(16),
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <View style={{ gap: scale(gapBetweenLines) }}>
          <Text style={[font.Headline, { color: C('Label/Light/Primary') }]}>
            {toolsLength} {i18n.t('Tools')}
          </Text>
        </View>
        <ActionArrow stylesToReplace={{}} />
      </BlockWrapper>
    </TourTarget>
  );
};

export default ToolsBlock;
